import type { TimePeriod } from '@carboncopyco/types';
import {
  DropdownFilter,
  type DropdownFilterItemContent,
  Separator,
  TextLargeParagraph,
} from '@carboncopyco/ui';
import type { SeriesOptionsType } from 'highcharts';
import type { ReactNode } from 'react';
import { ActivityLineChart, defaultTimePeriodOptions } from '../Charts';

export interface AnalyticsKpiLineChartProps {
  title?: string;
  chartName: string;
  subtitle: string;
  tooltipText?: string;
  description: string | ReactNode;
  kpiNumber: number | string;
  kpiRawNumber?: number | string;
  kpiPercentage?: number | string;
  negative?: boolean;
  units?: string;
  lineChartData?: {
    values: number[];
    timestamps: string[];
  };
  isLoading?: boolean;
  color?: SeriesOptionsType['color'];
  timePeriod: TimePeriod;
  setTimePeriod?: (id: TimePeriod) => void;
  timePeriodOptions?: DropdownFilterItemContent<TimePeriod>[];
  isError?: boolean;
  isEmpty?: boolean;
}

export const OverviewTabChartCard = ({
  title = 'Activity overview',
  subtitle,
  tooltipText,
  description,
  kpiNumber,
  kpiPercentage,
  negative,
  units,
  lineChartData,
  kpiRawNumber,
  isLoading,
  color,
  timePeriod,
  setTimePeriod,
  timePeriodOptions = defaultTimePeriodOptions,
  isEmpty,
  isError,
  chartName,
}: AnalyticsKpiLineChartProps) => {
  return (
    <div className="w-full flex flex-col bg-ds-accent3-100 rounded-lg border border-b-ds-natural-150 h-full">
      <div className="flex justify-between items-center h-ds-15 px-6">
        <TextLargeParagraph
          label={title}
          color="text-ds-natural-600"
        />
        {setTimePeriod && (
          <DropdownFilter
            rounded={false}
            capsuleWidth={140}
            contentWidth={140}
            items={timePeriodOptions}
            onSelect={setTimePeriod}
            selected={timePeriod}
            placeholder={timePeriod}
          />
        )}
      </div>
      <div className="w-full">
        <Separator horizontal />
      </div>
      <div className="flex flex-col p-6 grow">
        <ActivityLineChart
          subtitle={subtitle}
          color={color}
          kpiNumber={kpiNumber}
          description={description}
          lineChartData={lineChartData}
          isLoading={isLoading}
          kpiRawNumber={kpiRawNumber}
          kpiPercentage={kpiPercentage}
          isEmpty={isEmpty}
          isError={isError}
          negative={negative}
          tooltipText={tooltipText}
          units={units}
          name={chartName}
        />
      </div>
    </div>
  );
};
